import { appendQuery, createShareCardUri } from '@douban/rexxar-common/es/assets/js/uri'
import { obj2str } from '@douban/rexxar-common/es/assets/js/utils'
import UA from '@douban/rexxar-common/es/assets/js/ua'
import { getQuery } from '@douban/fe-utils'

export const DOUBAN_DOMAIN = 'https://www.douban.com'
export const YEAR = 2023
// 开发环境
// NODE_ENV 为 development 且 href query 中不包含 preview=true
export const IS_DEV = process.env.NODE_ENV === 'development' && getQuery(window.location.href).preview !== 'true'
// 预览环境
export const IS_PREVIEW = process.env.IS_PREVIEW || window.location.hostname.indexOf('.cup.douban') > -1

export const PRE_NUM = process.env.PRE_NUM || getQuery(window.location.href).pre
/*
// Jenkinsfile 中打包时不能指定 pre，因为 pre 经常变化
// 所以在这里多加一个兜底的处理，没有指定 pre 时，
// 通过 url 的 pre={num} 参数来指定使用哪个 pre
if (!PRE_NUM) {
  console.warn('⚠️  - 请在地址中增加 pre={num} 参数')
}
*/

const API_HOST = IS_DEV ? '' : 'https://m.douban.com'

// const API_HOST = 'https://m.douban.com'

export const API_HOME = `${API_HOST}/api/v2/chatbot/birthday20/home`
export const API_COLLECT_GIFT = `${API_HOST}/api/v2/chatbot/birthday20/collect_gift`
// 领取邀请券
export const API_COLLECT_INVITATION_LETTER = `${API_HOST}/api/v2/chatbot/birthday20/collect_invitation_letter`

export const CUSTOM_USER_ID = getQuery(window.location.href).user_id

export const USE_PROXY = getQuery(window.location.href).proxy == 'true'

export const URL = IS_DEV
  ? './'
  : IS_PREVIEW
  ? `https://20th-anniversary.cup.douban`
  : `https://c9.douban.com/app/20th-anniversary/`

// export const SCREENSHOOT_URL = `${URL}/screenshot.html`

// 客户端用到的参数：
const clientParams = {
  // 关闭自动旋转
  // autorotate: false,
  // 开启全屏
  fullscreen: true,
  // 隐藏 webview 导航栏
  // hidenav: true,
  // 2021 新增客户端监听截屏动作（since version 7.20
  // 值不为空，客户端就监听截屏
  // monitor_screenshot: true,
}

/*
appendQueryToString(`standbyme${YEAR}.douban.com`, clientParams)
返回：
{url}?autorotate=false&fullscreen=true&hidenav=true
*/
const appendQueryToString = (str: string, _query: { [k: string]: unknown }) => {
  const query = Object.assign({}, _query)

  for (const key in _query) {
    if (typeof query[key] === 'object' && query[key]) {
      query[key] = JSON.stringify(query[key])
    }
  }

  const qs = obj2str(query)
  if (!qs) {
    return str
  }
  const _url = `${str}?${qs}`
  return _url
}

/* ----- frodo 分发用(由后端处理) ----- */
// 2022 跟之前相比会特殊，之前是在 url 后面添加参数，2022 是在字符串后面添加参数。
// 如果带 https:// ，变成 url，在微信里调起豆瓣 app 后会打不开报告页面，而是进到豆瓣 app 下载页面
const dispathUriPath = appendQueryToString(`/20th-anniversary`, clientParams)
// console.log('dispathUriPath - ', dispathUriPath)
let dispatchURL = `https://www.douban.com/doubanapp/dispatch?uri=${encodeURIComponent(dispathUriPath)}`

// console.log('dispatchURL - ', dispatchURL)

// 豆瓣app之外访问时，需要带上这俩参数
if (!UA.isFrodo()) {
  dispatchURL = appendQuery(dispatchURL, {
    'download': '1',
    'copy_open': '1',
  })
}
export const DISPATCH_URL = dispatchURL

// console.log('DISPATCH_URL - ', DISPATCH_URL)

/* ----- app|web 用 ----- */

// 上线后的主页面地址
export const ONLINE_PAGE_URL = appendQuery(URL, clientParams)

export const SOURCE_LINK_URL = appendQuery(ONLINE_PAGE_URL, {
  from: 'link',
})

export const SOURCE_QRCODE_URL = appendQuery(ONLINE_PAGE_URL, {
  from: 'qrcode',
})

/* ---- 其他一些固定的常量 ---- */

// 生成的二维码图片
export const QRCODE_IMG = `https://img3.doubanio.com/dae/qrgen/v2/${encodeURIComponent(SOURCE_QRCODE_URL)}.png`

// 请求此链接，可以让客户端关闭 weview
export const closeWebViewUrl = 'douban://douban.com/webview/close'


export const DEFAULT_USER_AVATAR = 'https://img3.doubanio.com/icon/user_large.jpg'

// 微信分享用
export const API_WX_SIGNATURE = 'https://m.douban.com/j/wechat/signature'
export const WX_APP_ID = 'wxfcc940ed85b4ebb1'

/*
export const SHARE_CARD_CONFIG = {
  screenUrl: ONLINE_PAGE_URL,
  screenshot_type: 'webview',
  title: `参与活动，一起吃蛋糕吧！`,
  url: SOURCE_LINK_URL, // 页面的访问链接
  // extras: {
  //   topic_id: '42835',
  //   topic_name: '晒出你的豆瓣年度书影音报告'
  // }
}

export const captureUri = createShareCardUri(SHARE_CARD_CONFIG)

console.log('captureUri', captureUri)
*/

